export const LAYOUT_LIST_SUPPORTED = ['inquiries', 'verifications', 'reports', 'transactions'];
export const LAYOUT_TABLE_SUPPORTED = ['transactions'];
